// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //api: 'http://localhost:8000/api/v1',
  //api: 'http://localhost:8000/api',

  //api: 'http://134.209.189.128/bakend/adminmovil/public/index.php/api',

  api: 'https://adminseppi.exacto-digital.com/api',

  //api: 'http://134.209.189.128/bakend/adminmovil/public/index.php/api',

  // nooooapi: 'https://admin.exacto-digital.com/api/v1',

  "secure": false,
  "changeOrigin": true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
